export var RESET_CATEGORY = 'RESET_CATEGORY';
export var SET_DESCRIPTION = 'SET_DESCRIPTION';
export var SET_PRODUCTS = 'SET_PRODUCTS';
export var APPEND_PRODUCTS = 'APPEND_PRODUCTS';
export var PREPEND_PRODUCTS = 'PREPEND_PRODUCTS';
export var SET_TCVARS_TEMPLATE_NAME = 'SET_TCVARS_TEMPLATE_NAME';